<template>
  <div class="book ">
    <div class="middle-main">

      <div class="magazine-subscription">
        <magazine-order-info :magazineList="magazineListRes" />
      </div>
      <div class="line"></div>
      <!-- <div @click="openOrder()">
        <column-title title="E-book PERVIEW" desc="我要訂閱"/>
      </div> -->
      <tabs :tabs="tabs" :active-name="activeName" @chooseTopic="chooseTopic">
        <magazine-list class="book-lists" :magazineList="magazineListRes" />
        <div class="justify-center" style="padding-bottom: 50px; margin-top: 30px">
          <pagination :current-page="pageNum" :page-size="pageSize" :total="total" @changeSize="changeSize" />
        </div>
      </tabs>
    </div>

  </div>
</template>

<script>
import { mapState } from "vuex";
import swiperPolicy from "../common/swiper-policy.vue";
import newsList from "../common/news-list.vue";
import ColumnTitle from "../common/column-title.vue";
import tabs from "../common/tabs.vue";
import magazineList from "../common/magazine-list.vue";
import pagination from "../common/pagination.vue";
import { getMagazineList } from "@/assets/api/magazine.js";
import magazineOrderInfo from "../common/magazine-order-info.vue";

export default {
  components: {
    swiperPolicy,
    newsList,
    ColumnTitle,
    tabs,
    magazineList,
    pagination,
    magazineOrderInfo,
  },
  data() {
    return {
      tabs: [
        {
          name: "全部",
          id: "1",
        },
        {
          name: "2025年刊",
          id: "2025",
        },
        {
          name: "2024年刊",
          id: "2024",
        },
        {
          name: "2023年刊",
          id: "2023",
        },
      ],
      magazineListRes: [],
      total: 0,
      pageNum: 1,
      pageSize: 12,
      activeName: "1",
    };
  },
  created() {
    this.init();
  },
  methods: {
    chooseTopic(topic) {
      console.log(topic);
      this.activeName = topic;
      this.init();
    },
    init() {
      let data = {
        orderByColumn: "releaseTime",
        isAsc: "desc",
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        goodsTypeDict: 1,
      }
      if (this.activeName !== '1') {
        data['params[beginReleaseTime]'] = this.activeName + '-01-01';
        data['params[endReleaseTime]'] = this.activeName + '-12-31'
      }
      const formData = new FormData();
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          formData.append(key, data[key]);
        }
      }

      // 打印 FormData 的内容
      for (let pair of formData.entries()) {
        console.log(pair[0] + ': ' + pair[1]);
      }

      getMagazineList(formData).then((res) => {
        // console.log(res.data);
        this.total = res.data.total;
        this.magazineListRes = res.data.rows.map((item) => {
          item.image = item.image.split(",");
          item.image = item.image.map((it) => {
            it = !/^http/.test(it) ? this.$imgUrl + it : it;
            return it;
          });
          item.image = item.image[0];
          return item;
        });
      });
    },
    changeSize(e) {
      console.log(e);
      this.pageNum = e;
      this.init();
    },
    openOrder() {
      this.$router.push({
        path: `/order`,
      });
    }
  },
};
</script>

<style lang="less" scoped>
.book {
  padding-top: 80px;

  .book-lists {
    margin-top: 15px;
  }
}

.line {
  width: 100%;
  height: 1px;
  background-color: #E5E5EA;
  margin: 60px 0 30px;
}

.other-news {
  padding: 40px 0 80px;
}

@media (max-width: 768px) {
  .book {
    padding: 30px 20px;
  }
  .magazine-subscription{
    // padding: 0 10px;
  }
  .line{
    margin: 48px 0 40px;
  }
}
</style>
<style>
.book .el-tabs--card>.el-tabs__header .el-tabs__nav {
  justify-content: flex-start;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/views/magazine/index.vue